import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const TOPICS = gql`
  query Topics {
    topics {
      ...topicFields
    }
  }

  ${fragments.TOPIC_FRAGMENT}
`;

export const TOPIC_BY_NAME = gql`
  query TopicByName($topicName: String!) {
    topicByName(topicName: $topicName) {
      ...topicFields
      mostViewedWriters {
        ...identificationFields
      }
      followedBy {
        ...identificationFields
      }
      bookmarkedBy {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
  ${fragments.TOPIC_FRAGMENT}
`;
